module.exports = __webpack_public_path__ + "3ec06c38.png";